(function () {
  function tuneWelcomeOffer() {
    document.querySelectorAll('shopify-forms-embed').forEach(function (host) {
      host.style.setProperty('--forms-accent-color', '#3590cc', 'important');
      host.style.setProperty('--forms-discount-code-color', '#287aa9', 'important');
      host.style.setProperty('--body-text-color', '#526875', 'important');
      host.style.setProperty('--heading-text-color', '#102a3a', 'important');
      host.style.setProperty('--form-text-color', '#102a3a', 'important');
      host.style.setProperty('--form-background-color', '#f8fafb', 'important');
      host.style.setProperty('--button-text-color', '#ffffff', 'important');
      host.style.setProperty('--button-background-color', '#3590cc', 'important');
      host.style.setProperty('--button-close-background-color', '#ffffff', 'important');
      host.style.setProperty('--button-close-color', '#102a3a', 'important');
      host.style.setProperty('--container-background-color', '#f8fafb', 'important');
      host.style.setProperty('--form-field-border', '0 0 0 1px rgba(16,42,58,.2)', 'important');
      host.style.setProperty('--form-field-border-focused', '0 0 0 2px #3590cc', 'important');
      host.style.setProperty('--form-field-border-radius', '9px', 'important');
      host.style.setProperty('--button-border-radius', '9px', 'important');
      host.style.setProperty('--container-border-radius', '16px', 'important');
      host.style.setProperty('--container-shadow', '0 18px 48px rgba(16,42,58,.18)', 'important');
      host.style.setProperty('--forms-body-font', 'normal 500 14px Arial, sans-serif', 'important');
      host.style.setProperty('--forms-heading-font', 'normal 650 22px Arial, sans-serif', 'important');
    });
  }

  function observeWelcomeOffer() {
    tuneWelcomeOffer();
    var observer = new MutationObserver(tuneWelcomeOffer);
    observer.observe(document.documentElement, { childList: true, subtree: true });
    window.setTimeout(function () {
      observer.disconnect();
    }, 15000);
  }

  function setRevealState() {
    var items = document.querySelectorAll('.ccf-reveal, .shopify-section > .featured-collection, .shopify-section > .collection');
    if (!items.length) return;
    if (!('IntersectionObserver' in window) || window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
      items.forEach(function (item) { item.classList.add('ccf-visible'); });
      return;
    }
    var observer = new IntersectionObserver(function (entries) {
      entries.forEach(function (entry) {
        if (entry.isIntersecting) {
          entry.target.classList.add('ccf-visible');
          observer.unobserve(entry.target);
        }
      });
    }, { rootMargin: '0px 0px -8% 0px', threshold: 0.08 });
    items.forEach(function (item) {
      item.classList.add('ccf-reveal');
      observer.observe(item);
    });
  }

  function setProductType() {
    document.querySelectorAll('.product').forEach(function (product) {
      var text = product.textContent.toLowerCase();
      if (text.indexOf('stl download') !== -1 || text.indexOf('digital download') !== -1) {
        product.classList.add('ccf-product-has-stl');
      }
    });
  }

  function init() {
    observeWelcomeOffer();
    setRevealState();
    setProductType();
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', init, { once: true });
  } else {
    init();
  }
  document.addEventListener('shopify:section:load', init);
})();
